import actionTypes from "actions/actionTypes"
import { createRequestAction } from "../actions/shared"
import { getContentfulClient } from "../lib/contentful/contentfulClient"

export const fetchLibraryCategories = createRequestAction("FETCH_LIBRARY", async function () {
  const client = getContentfulClient()
  return await client.getEntries({ content_type: "category", include: 4 })
})

export const setCurrentLibraryCategory = (categorySlug) => ({
  type: actionTypes.SET_CURRENT_LIBRARY_CATEGORY,
  response: categorySlug
})
